import { AppShell } from '@mantine/core';
import { createPlayerTransactionRegistry } from 'entities/transaction';
import { playersTransactionPageModel } from '../../model';
import cls from './players-transaction-page.module.scss';

export const PlayerTransactionRegistry = createPlayerTransactionRegistry(
	playersTransactionPageModel.playerTransactionRegistryModel,
);

export const PlayersTransactionPage = () => (
	<AppShell.Main className={cls.playersTransactionPage}>
		<PlayerTransactionRegistry />
	</AppShell.Main>
);
